import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Heading/Heading';

class Heading extends React.Component{

  render(){
    let section = this.props.section;
    return (
      <section className="heading">
        <div id="headingContent" style={{minHeight: '155px'}}>
          <InlineEditableElement el='h1' {...this.props.inlineEditorProps}
                                 fontFamilyChanged={this.props.fontFamilyChanged} className="intro-heading" html={section.prop('title')} onChange={this.props.titleChanged.bind(this)} inlineEditingEnabled={this.props.inlineEditingEnabled}/>
          {typeof section.prop('subtitle') !== 'undefined' || this.props.inlineEditingEnabled ? <InlineEditableElement fontFamilyChanged={this.props.fontFamilyChanged} html={section.prop('subtitle')} {...this.props.inlineEditorProps} className="intro-lead-in" onChange={this.props.subtitleChanged.bind(this)} inlineEditingEnabled={this.props.inlineEditingEnabled} /> : null}
          <hr className="secondary"/>
        </div>
      </section>
    );
  }

}

export default hoc(Heading);
